<body>
  <div class="session">
    <div class="left"></div>
    <form
      [formGroup]="loginForm"
      (ngSubmit)="onSubmit()"
      class="log-in login-form"
      autocomplete="off"
    >
      <h4>Welcome Back</h4>
      <p>Signin to your Account</p>
      <div class="floating-label">
        <input
          type="email"
          id="email"
          placeholder="Email"
          class="form-control"
          formControlName="email"
          name="email"
          autocomplete="off"
        />
        <!-- <label for="email">Email:</label> -->
      </div>
      <div class="floating-label">
        <input
          type="password"
          id="password"
          placeholder="Password"
          class="form-control"
          formControlName="password"
          name="password"
          autocomplete="off"
        />
      </div>
      <span class="alert-message" *ngIf="errorString">{{errorString}}</span>
      <button type="submit" style="width: 100%">
      <span *ngIf="!isSubmitting">SIGN IN</span>
      <span *ngIf="isSubmitting" class="spinner-border sr-only" role="status"></span>
    </button>
    </form>
  </div>
</body>
